import { render, staticRenderFns } from "./activationBonusList.vue?vue&type=template&id=3b584a8a&scoped=true"
import script from "./activationBonusList.vue?vue&type=script&lang=js"
export * from "./activationBonusList.vue?vue&type=script&lang=js"
import style0 from "./activationBonusList.vue?vue&type=style&index=0&id=3b584a8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b584a8a",
  null
  
)

export default component.exports